import { combineReducers } from 'redux';

import {
  CHANGE_PAGE_APLICATION,
  MOKA_CAPITAL_SENDING_REQUEST,
  MOKA_CAPITAL_SET_ALLOW_TO_APPLY,
  MOKA_CAPITAL_SET_LOAN_PERIOD,
  MOKA_CAPITAL_SET_PAGE,
  SET_APPROVAL,
  SET_BORROWER_PROFILE,
  SET_DASHBOARD_LIST,
  SET_PERMISSION_STATE,
  SET_TO_REDUCER_BY_FIELDNAME,
  CHANGE_CAPITAL_TAB,
  SET_KOINWORKS_SUPPORTED_LOCATIONS,
} from '../../actions/capital/constants';
import createReducer from '../../utils/createReducer';
import fastLoan from './fastLoan';

const applicationPage = createReducer(1, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [CHANGE_PAGE_APLICATION]: (draft, { payload }) => payload.applicationPage,
});

const approvals = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SET_APPROVAL]: (draft, { payload }) => payload.approvals,
});

const borrowerProfile = createReducer(
  {},
  {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    [SET_BORROWER_PROFILE]: (draft, { payload }) => payload.borrowerProfile,
  }
);

const businessCategory = createReducer([], {});

const businessType = createReducer([], {});

const capitalPage = createReducer('', {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [MOKA_CAPITAL_SET_PAGE]: (draft, { payload }) => payload.capitalPage,
});

const dashboardList = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SET_DASHBOARD_LIST]: (draft, { payload }) => payload.dashboard,
});

const isAllowed = createReducer(false, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [SET_PERMISSION_STATE]: (draft, { payload }) => payload.setPermissionsState,
});

const isAllowToApply = createReducer(false, {
  [MOKA_CAPITAL_SET_ALLOW_TO_APPLY]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isAllowToApply,
});

const loanPeriod = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [MOKA_CAPITAL_SET_LOAN_PERIOD]: (draft, { payload }) => payload.loanPeriod,
});

const sendingRequest = createReducer(false, {
  [MOKA_CAPITAL_SENDING_REQUEST]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.sendingRequest,
});

const capitalTab = createReducer('', {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [CHANGE_CAPITAL_TAB]: (draft, { payload }) => payload.tabId,
});

const koinworksSupportedLocations = createReducer(
  {
    BUSINESS_FORM: [],
    PERSONAL_FORM: [],
    CURRENT_RESIDENCE_FORM: [],
  },
  {
    [SET_KOINWORKS_SUPPORTED_LOCATIONS]: (draft, { payload }) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'
      draft[payload.section] = payload.supportedLocations;
      return draft;
    },
  }
);
const reducer = combineReducers({
  applicationPage,
  approvals,
  borrowerProfile,
  businessCategory,
  businessType,
  capitalPage,
  dashboardList,
  isAllowed,
  isAllowToApply,
  loanPeriod,
  sendingRequest,
  capitalTab,
  fastLoan,
  koinworksSupportedLocations,
});

// FIXME This custom reducer is needed because `SET_TO_REDUCER_BY_FIELDNAME` is
// altering the shape of state.
function customAndDoNotEverDoThisInTheFutureReducer(state, action) {
  // 'SET_TO_REDUCER_BY_FIELDNAME' is modifying state shape
  if (action.type === SET_TO_REDUCER_BY_FIELDNAME) {
    // If there is no initial state, run once to get it
    if (!state) {
      // eslint-disable-next-line no-param-reassign
      state = reducer(state, action);
    }
    const { fieldName, value } = action.payload;
    return {
      ...state,
      [fieldName]: value,
    };
  }

  // For other actions, use the composed reducer
  return reducer(state, action);
}

export default customAndDoNotEverDoThisInTheFutureReducer;
